"use strict";

angular.module("models").service("CoursesService", ["ApiService", function (ApiService) {
  var that = this;

  var params = {
    name: "courses",
    attributesForCache: ["name"],
    formatName: function formatName(element) {
      return element.name ? element.name : "???";
    },
    defaultOrder: { startDate: -1 }
  };

  angular.extend(that, ApiService.getModelBis(params));
}]);